import { api_tchCheckPwd, api_stuCheckPwd, api_tchVerifyPhoneState, api_stuGetStuPwdRemind, api_tchFeedbackUnReadNum } from '@/api/javaApi'
import { getTchRecentNotReadNotice, updateNoticeIsReatState } from '@/api/educational'

const state = {
    passwordState: 0, // 0: 未检查, 1: 检查中, 2: 需要弹窗, 3: 已处理
    phoneState: 0, // 0: 未检查, 1: 检查中, 2: 需要弹窗, 3: 已处理
    phoneApiState: null, // api_tchVerifyPhoneState 接口的实际返回值
    noticeState: 0, // 0: 未检查, 1: 检查中, 2: 需要弹窗, 3: 已处理
    currentDialog: null, // 当前显示的弹窗类型: 'phone', 'notice', 'password', null
    noticeData: null, // 系统通知数据
    isChecking: false, // 是否正在进行全局检查

    // 保持向后兼容的旧字段
    checkAccountState: false,
    checkPhoneState: false,
    defaultPassword: '',
    noticeNolook: 0,
    feedbackUnReadNum: 0,
}

const mutations = {
    SET_PASSWORD_STATE(state, status) {
        state.passwordState = status
    },

    SET_PHONE_STATE(state, status) {
        state.phoneState = status
    },

    SET_PHONE_API_STATE(state, status) {
        state.phoneApiState = status
    },

    SET_NOTICE_STATE(state, status) {
        state.noticeState = status
    },

    SET_CURRENT_DIALOG(state, dialogType) {
        state.currentDialog = dialogType
    },

    SET_NOTICE_DATA(state, data) {
        state.noticeData = data
    },

    SET_CHECKING(state, status) {
        state.isChecking = status
    },

    RESET_ALL_STATES(state) {
        state.passwordState = 0
        state.phoneState = 0
        state.noticeState = 0
        state.currentDialog = null
        state.noticeData = null
        state.isChecking = false
    },

    // 保持向后兼容的旧mutations
    CHECK_ACCOUNT_STATE(state, data) {
        state.checkAccountState = data
    },
    CHECK_PHONE_STATE(state, data) {
        state.checkPhoneState = data
    },
    DEFAULT_PASSWORD(state, data) {
        state.defaultPassword = data;
    },
    // 系统通知未读数
    NOTICE_NOLOOK(state, data) {
        console.log('noticeNolook', data)
        sessionStorage.setItem('notReadNum', state.noticeNolook = data)
    },
    // 计算系统通知未读数
    REDUCE_NOTICE_NOLOOK(state, date = -1) {
        console.log('state.noticeNolook', state.noticeNolook)
        if (state.noticeNolook > 0) {
            sessionStorage.setItem('notReadNum', state.noticeNolook = date === 0 ? 0 : state.noticeNolook + date)
        }
    },
    // 反馈未读数
    FEEDBACK_UNREAD_NUM(state, data) {
        state.feedbackUnReadNum = data
    },
    // 计算反馈未读数
    REDUCE_FEEDBACK_UNREAD_NUM(state, date = -1) {
        if (state.feedbackUnReadNum > 0) {
            state.feedbackUnReadNum = date === 0 ? 0 : state.feedbackUnReadNum + date
        }
    },
}

const actions = {
    // 检查密码状态
    async checkPassword({ commit, rootState }) {
        // 检查sessionStorage中是否已经处理过密码检查
        const updatePasswordStorage = sessionStorage.getItem('updatePasswordStorage')
        if (updatePasswordStorage === 'false') {
            // 本次登录期间已经处理过，不再弹出
            commit('SET_PASSWORD_STATE', 3) // 不需要弹窗
            return
        }

        commit('SET_PASSWORD_STATE', 1) // 检查中

        try {
            let needChange = false
            if (rootState.user.identity === 1) {
                // 教师
                needChange = await api_tchCheckPwd()
            } else if (rootState.user.identity === 2) {
                // 学生
                const stuCheckPwdRes = await api_stuCheckPwd()
                if (stuCheckPwdRes) {
                    needChange = await api_stuGetStuPwdRemind()
                } else {
                    needChange = stuCheckPwdRes
                }
            }

            if (needChange) {
                commit('SET_PASSWORD_STATE', 2) // 需要弹窗
            } else {
                commit('SET_PASSWORD_STATE', 3) // 已处理
                // 设置标记，避免重复调用接口
                sessionStorage.setItem('updatePasswordStorage', 'false')
            }
        } catch (error) {
            console.error('检查密码状态失败:', error)
            commit('SET_PASSWORD_STATE', 3) // 已处理
            // 设置标记，避免重复调用接口
            sessionStorage.setItem('updatePasswordStorage', 'false')
        }
    },

    // 检查手机验证状态
    async checkPhone({ commit, rootState }) {
        // 只有教师身份才需要手机号验证
        if (rootState.user.identity !== 1) {
            commit('SET_PHONE_STATE', 3) // 非教师身份，不需要弹窗
            // 设置标记，避免重复调用接口
            sessionStorage.setItem('updatePhoneStorage', 'false')
            return
        }

        // 超管端不弹出手机号验证弹框
        if (window.location.pathname.includes('/background/')) {
            commit('SET_PHONE_STATE', 3) // 超管端，不需要弹窗
            // 设置标记，避免重复调用接口
            sessionStorage.setItem('updatePhoneStorage', 'false')
            return
        }

        // 检查sessionStorage中是否已经处理过手机号验证
        const updatePhoneStorage = sessionStorage.getItem('updatePhoneStorage')
        if (updatePhoneStorage === 'false') {
            // 本次登录期间已经处理过，不再弹出
            commit('SET_PHONE_STATE', 3) // 不需要弹窗
            return
        }

        commit('SET_PHONE_STATE', 1) // 检查中

        try {
            const response = await api_tchVerifyPhoneState()
            // 保存接口的实际返回值
            commit('SET_PHONE_API_STATE', response)

            if (response === 0) {
                commit('SET_PHONE_STATE', 3) // 不需要弹窗
                // 设置标记，避免重复调用接口
                sessionStorage.setItem('updatePhoneStorage', 'false')
            } else if (response === 2) {
                commit('SET_PHONE_STATE', 2) // 需要弹窗（只读模式）
            } else {
                commit('SET_PHONE_STATE', 2) // 需要弹窗（正常模式）
            }
        } catch (error) {
            console.error('检查手机验证状态失败:', error)
            commit('SET_PHONE_STATE', 3) // 已处理
            // 设置标记，避免重复调用接口
            sessionStorage.setItem('updatePhoneStorage', 'false')
        }
    },

    // 检查系统通知
    async checkNotice({ commit, rootState }) {
        // 只有教师身份才需要检查系统通知
        if (rootState.user.identity !== 1) {
            commit('SET_NOTICE_STATE', 3) // 非教师身份，不需要弹窗
            return
        }
        // 检查sessionStorage中是否已经处理过系统通知检查
        // const updateNoticeStorage = sessionStorage.getItem('updateNoticeStorage')
        // if (updateNoticeStorage === 'false') {
        //     // 本次登录期间已经处理过，不再弹出
        //     commit('SET_NOTICE_STATE', 3) // 不需要弹窗
        //     dispatch('storeGetTchRecentNotReadNotice') // 确保更新系统通知数量
        //     return
        // }

        commit('SET_NOTICE_STATE', 1) // 检查中
        try {
            const response = await getTchRecentNotReadNotice()
            commit('NOTICE_NOLOOK', response.notReadNum)
            if (response && response.notReadNotice) {
                // 查找需要弹窗的通知 (type: 1=仅标题弹窗, 2=标题+内容弹窗)
                const popupNotice = response.notReadNotice.noticeInfo
                if (popupNotice) {
                    popupNotice.noticeUserId = response.notReadNotice.id,
                        commit('SET_NOTICE_DATA', popupNotice)
                    commit('SET_NOTICE_STATE', 2) // 需要弹窗
                } else {
                    commit('SET_NOTICE_STATE', 3) // 已处理
                    // 设置标记，避免重复调用接口
                    sessionStorage.setItem('updateNoticeStorage', 'false')
                }
            } else {
                commit('SET_NOTICE_STATE', 3) // 已处理
                // 设置标记，避免重复调用接口
                sessionStorage.setItem('updateNoticeStorage', 'false')
            }
        } catch (error) {
            console.error('检查系统通知失败:', error)
            commit('SET_NOTICE_STATE', 3) // 已处理
            // 设置标记，避免重复调用接口
            sessionStorage.setItem('updateNoticeStorage', 'false')
        }
    },

    // 全局检查 - 按优先级只显示一个弹窗
    async performGlobalCheck({ dispatch, commit, getters, state }) {
        if (getters.isChecking) return

        commit('SET_CHECKING', true)

        try {
            // 并行检查所有状态
            // await Promise.all([
            await dispatch('checkNotice')
            if (state.noticeState !== 2) {
                setTimeout(async () => {
                    const hasShownDialogStorage = sessionStorage.getItem('hasShownDialogStorage')
                    if (hasShownDialogStorage && hasShownDialogStorage === 'true') {
                        return
                    }
                    await dispatch('checkPhone')
                    if (state.phoneState !== 2) {
                        await dispatch('checkPassword')
                    }
                    sessionStorage.setItem('hasShownDialogStorage', 'true')
                }, 20)
            }
            // ])

            // 延迟500ms后确定要显示的弹窗
            setTimeout(() => {
                const dialogToShow = getters.getHighestPriorityDialog
                commit('SET_CURRENT_DIALOG', dialogToShow)
                commit('SET_CHECKING', false)
            }, 500)

        } catch (error) {
            console.error('全局检查失败:', error)
            commit('SET_CHECKING', false)
        }
    },

    // 处理弹窗显示完成
    handleDialogShown({ commit, dispatch, state }, dialogType) {
        // 将对应状态设置为已处理
        switch (dialogType) {
            case 'phone':
                commit('SET_PHONE_STATE', 3)
                break
            case 'notice':
                updateNoticeIsReatState({
                    noticeUserId: state.noticeData.noticeUserId,
                }).then((res) => {
                    if (res.is_update) {
                        commit('SET_NOTICE_STATE', 3)
                        dispatch('storeGetTchRecentNotReadNotice')
                    }
                })
                break
            case 'password':
                commit('SET_PASSWORD_STATE', 3)
                break
        }
        commit('SET_CURRENT_DIALOG', null)
    },

    // 保持向后兼容的旧actions
    methodSetDetaultPassword(store) {
        console.log(store)
        const domain = store.rootState.user.schoolInfo.domain
        store.commit('DEFAULT_PASSWORD', domain + '123456')
    },

    storeMethodCheckAccount(store, state = true) {
        store.commit('CHECK_ACCOUNT_STATE', false)
        setTimeout(async () => {
            if (Object.keys(store.rootState.user.userInfo).length > 0) {
                store.commit('CHECK_ACCOUNT_STATE', state)
            }
        }, 500)
    },

    storeMethodCheckPhone(store, state = true) {
        store.commit('CHECK_PHONE_STATE', false)
        setTimeout(async () => {
            if (Object.keys(store.rootState.user.userInfo).length > 0) {
                store.commit('CHECK_PHONE_STATE', state)
            }
        }, 500)
    },

    async storeGetTchRecentNotReadNotice(store) {
        const res = await getTchRecentNotReadNotice()
        if (res) {
            store.commit('NOTICE_NOLOOK', res.notReadNum)
            return res
        }
        return res
    },

    async storeGetTchFeedbackUnReadNum(store) {
        const res = await api_tchFeedbackUnReadNum()
        store.commit('FEEDBACK_UNREAD_NUM', Number(res))
    }
}

const getters = {
    passwordState: state => state.passwordState,
    phoneState: state => state.phoneState,
    phoneApiState: state => state.phoneApiState,
    noticeState: state => state.noticeState,
    currentDialog: state => state.currentDialog,
    noticeData: state => state.noticeData,
    isChecking: state => state.isChecking,

    // 获取最高优先级需要显示的弹窗
    getHighestPriorityDialog: state => {
        // 优先级: notice > phone > password
        if (state.noticeState === 2) return 'notice'
        if (state.phoneState === 2) return 'phone'
        if (state.passwordState === 2) return 'password'
        return null
    },

    // 是否有任何弹窗需要显示
    hasDialogToShow: state => {
        return state.phoneState === 2 || state.noticeState === 2 || state.passwordState === 2
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}